import { render } from "./AmenitiesSvg.vue?vue&type=template&id=118b87dd&scoped=true"
import script from "./AmenitiesSvg.vue?vue&type=script&lang=js"
export * from "./AmenitiesSvg.vue?vue&type=script&lang=js"

import "./AmenitiesSvg.vue?vue&type=style&index=0&id=118b87dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118b87dd"]])

export default __exports__